import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row, Label } from "reactstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { subYears } from 'date-fns';
import DatePicker from "react-datepicker";

import { checkWhiteSpaces, number, alphaNumeric, email, alphabetsOnly, apiErrors, notify, isValidPAN, validateNumberTypeWithLength } from '../../../../../../../../helper';
import { API } from '../../../../../../../../config/constants';

import { cloneDeep } from 'lodash';
import HeaderTitle from '../../../../../../../common/HeaderTitle';
import TooltipCustom from '../../../../../../../common/Tooltip';
import { TextFieldHookForm, SearchableSelectHookForm } from '../../../../../../../layout/HookFormInputs';
import FileUpload from '../../FileUpload';
import { getCountryService, getStateSelection, getTypeEstablishment } from '../../../../../../supplierListAll/Actions';
import axiosHelper from '../../../../../../../../axiosHelper';
import LoaderCustom from '../../../../../../../common/LoaderCustom';

let ownerInitialData = {
    Name: "",
    City: "",
    CountryId: "",
    DateOfBirth: "",
    AadharNo: "",
    Mobile: "",
    Email: "",
    PanNo: "",
    DinNo: ""
}
const fileConfig = {
    rentAgreementAttachment: {
        allowedFileTypes: [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword", // Allow .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
    }
}

const maxDateForDateOfBirth = subYears(new Date(), 18);
const tomorrowDate = new Date();
tomorrowDate.setDate(tomorrowDate.getDate());
let radioValidateMsg = "This field is required.";
let proofTypeListData = [];

const ContactDetails = (props) => {

    // let { supplierDetail } = props;
    const [establishmentTypes, setEstablishmentTypes] = useState(null);
    const [countryListForOwners, setCountryListForOwners] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [proofTypeList, setProofTypeList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [workAddressCountryStateList, setWorkAddressCountryStateList] = useState([])
    const [registeredAddressCountryStateList, setRegisteredAddressCountryStateList] = useState([])
    const [rentAgreementAttachment, setRentAgreementAttachment] = useState(null)
    const [isRegisteredAddressSameAsWork, setIsRegisteredAddressSameAsWork] = useState(false)
    const [showTabLoader, setShowTabLoader] = useState(true)
    const [supplierDetail, setSupplierDetail] = useState(null)
    const [vendorRequirementRegistrationId, setVendorRequirementRegistrationId] = useState(0)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            setVendorRequirementRegistrationId(id);
            GetKYS1DetailByVendorRRId(id)
        }
        getProofTypeList()
        getCategoryMaster()
    }, []);

    const GetKYS1DetailByVendorRRId = (id) => {
        axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
            .then(async (res) => {
                setSupplierDetail(res?.data?.Data);
                props.setVendorKys1Data(res?.data?.Data)
            })
            .catch((error) => {

            });
    }

    const formController = useForm({
        // defaultValues: {
        //     // OwnersShipDetail: [ownerInitialData]
        // },
        mode: "onChange",
        reValidateMode: "onChange",
    });


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        setValue,
        trigger,
        getValues,
        reset,
        resetField,
        formState: { errors },
        control,
    } = formController;

    const useFieldArrayController = useFieldArray({
        control,
        name: "OwnersShipDetail"
    });

    const { fields, append, remove } = useFieldArrayController;

    let OwnersShipDetail = watch("OwnersShipDetail");
    let isWorkAddressTypeRented = watch("VendorWorkAddressDetail.WorkAddressType") === 'rented';
    let registeredAddressCountry = watch("VendorRegisteredAddressDetail.CountryId");
    let registrationDetailCompanyTypeId = watch("RegistrationDetail.CompanyTypeId");

    const setProofTypeListBasedOnAddress = (addrType) => {
        let items = [];
        if (addrType === 'owned') {
            items = proofTypeListData.filter(el => el.label !== "Rent Agreement");
            setProofTypeList(items)
        }
        if (addrType === 'rented') {
            items = proofTypeListData.filter(el => el.label === "Rent Agreement");
            setProofTypeList(items)
            if (items?.length) {
                setValue("VendorWorkAddressDetail.ProofTypeId", items[0]);
            }
        }
    }

    useEffect(() => {
        if (watch("VendorWorkAddressDetail.WorkAddressType") === 'owned') {
            setValue("VendorWorkAddressDetail.AgreementExpiryDate", null)
            setValue("VendorWorkAddressDetail.ProofTypeId", null);
            setProofTypeListBasedOnAddress('owned')

        }
        if (watch("VendorWorkAddressDetail.WorkAddressType") === 'rented') {
            setValue("VendorWorkAddressDetail.ProofTypeId", null);
            setProofTypeListBasedOnAddress('rented')
        }
    }, [watch("VendorWorkAddressDetail.WorkAddressType")])

    useEffect(() => {
        let totalAddedOwners = OwnersShipDetail?.length;
        setValue("RegistrationDetail.NumberOfOwners", totalAddedOwners)
    }, [OwnersShipDetail])

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    const toggleRegisteredAddressSameAsWork = (sameCheck) => {
        setIsRegisteredAddressSameAsWork(!sameCheck);
        setRegisteredAddressCountryStateList([])
        let currentFormData = getValues();
        if (!sameCheck) {
            let countryId = currentFormData?.VendorWorkAddressDetail?.CountryId;
            let stateId = currentFormData?.VendorWorkAddressDetail?.StateId;
            setValue("VendorRegisteredAddressDetail", currentFormData?.VendorWorkAddressDetail);
            setValue("VendorRegisteredAddressDetail.CountryId", countryId);
            setValue("VendorRegisteredAddressDetail.StateId", stateId);
            setTimeout(() => {
                trigger("VendorRegisteredAddressDetail.House")
                trigger("VendorRegisteredAddressDetail.Street")
                trigger("VendorRegisteredAddressDetail.City")
                trigger("VendorRegisteredAddressDetail.District")
                trigger("VendorRegisteredAddressDetail.CountryId")
                trigger("VendorRegisteredAddressDetail.StateId")
                trigger("VendorRegisteredAddressDetail.PostalCode")
                trigger("VendorRegisteredAddressDetail.Mobile")
                trigger("VendorRegisteredAddressDetail.TelephoneNumber")
                trigger("VendorRegisteredAddressDetail.Email")
            }, 100);
        } else {
            let emptyRegisteredAddress = {
                Street: "",
                House: "",
                CountryId: null,
                StateId: null,
                District: "",
                City: "",
                PostalCode: "",
                Mobile: "",
                Email: "",
                TelephoneNumber: ""
            }
            setValue("VendorRegisteredAddressDetail", emptyRegisteredAddress)
        }

    }

    const setContactDetailsFormEditData = (KYS1ContactDetails) => {
        //if OwnersShipDetail is null then set it to empty array to make it iterable
        if (!KYS1ContactDetails?.OwnersShipDetail) {
            KYS1ContactDetails.OwnersShipDetail = [];
        }

        let resetFormData = {
            RegistrationDetail: {
                ...KYS1ContactDetails?.RegistrationDetail,
                DomesticandOverseas: KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas.toString(),
                VendorRelation: KYS1ContactDetails?.RegistrationDetail?.VendorRelation.toString(),
                CompanyTypeId: !!KYS1ContactDetails?.RegistrationDetail?.CompanyTypeId ? {
                    label: KYS1ContactDetails?.RegistrationDetail?.CompanyTypeName,
                    value: KYS1ContactDetails?.RegistrationDetail?.CompanyTypeId
                } : null,
                VendorCategoryId: !!KYS1ContactDetails?.RegistrationDetail?.VendorCategoryId ? {
                    label: KYS1ContactDetails?.RegistrationDetail?.VendorCategoryName,
                    value: KYS1ContactDetails?.RegistrationDetail?.VendorCategoryId
                } : null,
            },
            VendorWorkAddressDetail: {
                ...KYS1ContactDetails?.VendorWorkAddressDetail,
                WorkAddressType: KYS1ContactDetails?.VendorWorkAddressDetail?.Own ? "owned" : (KYS1ContactDetails?.VendorWorkAddressDetail?.Rented ? "rented" : ""),
                AgreementExpiryDate: KYS1ContactDetails?.VendorWorkAddressDetail?.AgreementExpiryDate ?
                    new Date(KYS1ContactDetails?.VendorWorkAddressDetail?.AgreementExpiryDate) : null,
                StateId: !!KYS1ContactDetails?.VendorWorkAddressDetail?.StateId ? {
                    label: KYS1ContactDetails?.VendorWorkAddressDetail?.StateName,
                    value: KYS1ContactDetails?.VendorWorkAddressDetail?.StateId
                } : null,
                CountryId: !!KYS1ContactDetails?.VendorWorkAddressDetail?.CountryId ? {
                    label: KYS1ContactDetails?.VendorWorkAddressDetail?.CountryName,
                    value: KYS1ContactDetails?.VendorWorkAddressDetail?.CountryId
                } : null,
                // ProofTypeId: !!KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeId ? {
                //     label: KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeName,
                //     value: KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeId
                // } : null,
            },
            VendorRegisteredAddressDetail: {
                ...KYS1ContactDetails?.VendorRegisteredAddressDetail,
                StateId: !!KYS1ContactDetails?.VendorRegisteredAddressDetail?.StateId ? {
                    label: KYS1ContactDetails?.VendorRegisteredAddressDetail?.StateName,
                    value: KYS1ContactDetails?.VendorRegisteredAddressDetail?.StateId
                } : null,
                CountryId: !!KYS1ContactDetails?.VendorRegisteredAddressDetail?.CountryId ? {
                    label: KYS1ContactDetails?.VendorRegisteredAddressDetail?.CountryName,
                    value: KYS1ContactDetails?.VendorRegisteredAddressDetail?.CountryId
                } : null,
            },
            OwnersShipDetail: KYS1ContactDetails?.OwnersShipDetail?.map(owner => ({
                ...owner,
                DateOfBirth: owner?.DateOfBirth ? new Date(owner?.DateOfBirth) : null,
                CountryId: !!owner?.CountryId ? {
                    label: owner?.CountryName,
                    value: owner?.CountryId
                } : null,
            }))
        }

        if (KYS1ContactDetails?.VendorWorkAddressDetail?.CountryId) {
            handleCountryChange(KYS1ContactDetails?.VendorWorkAddressDetail?.CountryId, 'work', false);
        }
        if (KYS1ContactDetails?.VendorRegisteredAddressDetail?.CountryId) {
            handleCountryChange(KYS1ContactDetails?.VendorRegisteredAddressDetail?.CountryId, 'registered', false);
        }
        if (KYS1ContactDetails?.OwnersShipDetail?.length === 0) {
            setOwnersBasedOnCompanyType(KYS1ContactDetails?.RegistrationDetail?.CompanyTypeId, KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas, true)
        }
        reset(resetFormData);
        setTimeout(() => {
            reset(resetFormData);
            let rentedFile = (KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocumentName && KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument) ? {
                fileName: KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocumentName,
                fileUrl: KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument,
                base64String: "",
                fileType: ""
            } : null;
            setValue("VendorWorkAddressDetail.OwnRentedDocumentAttachment", rentedFile)
        }, 1000);
        setIsRegisteredAddressSameAsWork(KYS1ContactDetails?.VendorWorkAddressDetail?.IsSameAsWorkAddress)
        setRentAgreementAttachment({
            fileName: KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocumentName,
            fileUrl: KYS1ContactDetails?.VendorWorkAddressDetail?.OwnRentedDocument,
            base64String: "",
            fileType: ""
        });
        hidePageLoader()
    };

    useEffect(() => {
        if (supplierDetail?.KYS1ContactDetails) {
            getTypeOfEstablishment(supplierDetail)
            getCountryMasterList(supplierDetail)
            setContactDetailsFormEditData(supplierDetail?.KYS1ContactDetails);
            let proof = !!supplierDetail?.KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeId ? {
                label: supplierDetail?.KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeName,
                value: supplierDetail?.KYS1ContactDetails?.VendorWorkAddressDetail?.ProofTypeId
            } : null
            setTimeout(() => {
                setValue("VendorWorkAddressDetail.ProofTypeId", proof)
            }, 1500);
        }
    }, [supplierDetail]);

    const onSubmitContactDetails = (values) => {
        //For overseas supplier minimum 1 owner is requried for all company type
        if (
            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 &&
            (!values?.OwnersShipDetail || values?.OwnersShipDetail?.length < 1)
        ) {
            notify.error("Minimum one owner is required.");
            return;
        }
        // For indian supplier, company type "Company", "LLP", "Partnership" min. two owners details is mandatory        
        if (
            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 &&
            (
                values?.RegistrationDetail?.CompanyTypeId?.value === 1 ||
                values?.RegistrationDetail?.CompanyTypeId?.value === 3 ||
                values?.RegistrationDetail?.CompanyTypeId?.value === 4
            )
            &&
            (!values?.OwnersShipDetail || values?.OwnersShipDetail?.length < 2)
        ) {
            notify.error("Minimum two owners are required.");
            return;
        }
        // For indian supplier, company type "HUF", "OPC", "Proprietorship", "Society" min. 1 owner details is mandatory        
        if (
            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 &&
            (
                values?.RegistrationDetail?.CompanyTypeId?.value === 2 ||
                values?.RegistrationDetail?.CompanyTypeId?.value === 5 ||
                values?.RegistrationDetail?.CompanyTypeId?.value === 6 ||
                values?.RegistrationDetail?.CompanyTypeId?.value === 7
            )
            &&
            (!values?.OwnersShipDetail || values?.OwnersShipDetail?.length < 1)
        ) {
            notify.error("Minimum one owner is required.");
            return;
        }

        let payload = cloneDeep(values);

        payload.RegistrationDetail.VendorRelation = supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.VendorRelation;
        payload.RegistrationDetail.DomesticandOverseas = supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas;
        payload.RegistrationDetail.CompanyTypeId = values?.RegistrationDetail?.CompanyTypeId?.value;
        payload.RegistrationDetail.VendorCategoryId = values?.RegistrationDetail?.VendorCategoryId?.value;
        payload.RegistrationDetail.NumberOfOwners = values?.OwnersShipDetail?.length;
        payload.RegistrationDetail.KYS1RegistrationId = supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.KYS1RegistrationId;
        payload.RegistrationDetail.VendorRequirementRegistrationId = vendorRequirementRegistrationId;

        payload.VendorWorkAddressDetail.StateId = values?.VendorWorkAddressDetail?.StateId?.value;
        payload.VendorWorkAddressDetail.CountryId = values?.VendorWorkAddressDetail?.CountryId?.value;
        payload.VendorWorkAddressDetail.ProofTypeId = values?.VendorWorkAddressDetail?.ProofTypeId?.value;
        payload.VendorWorkAddressDetail.IsSameAsWorkAddress = isRegisteredAddressSameAsWork;

        payload.VendorRegisteredAddressDetail.StateId = values?.VendorRegisteredAddressDetail?.StateId?.value;
        payload.VendorRegisteredAddressDetail.CountryId = values?.VendorRegisteredAddressDetail?.CountryId?.value;

        // //sending this to avoid error
        // payload.VendorRegisteredAddressDetail.ProofTypeId = values?.VendorRegisteredAddressDetail?.ProofTypeId?.value;

        if (payload.VendorWorkAddressDetail?.WorkAddressType === "owned") {
            payload.VendorWorkAddressDetail.Own = true;
            payload.VendorWorkAddressDetail.Rented = false;
        } else if (payload.VendorWorkAddressDetail?.WorkAddressType === "rented") {
            payload.VendorWorkAddressDetail.Own = false;
            payload.VendorWorkAddressDetail.Rented = true;
        }

        if (values?.OwnersShipDetail?.length) {
            payload.OwnersShipDetail = values?.OwnersShipDetail?.map(obj => {
                // Check if the "CountryId" property is an object with "value" key
                if (typeof obj.CountryId === 'object' && obj.CountryId.hasOwnProperty('value')) {
                    // Replace "CountryId" with its "value" property
                    obj.CountryId = obj.CountryId.value;
                }
                return obj; // Return the modified object
            });
        }

        setShowTabLoader(true)
        delete payload.VendorRegisteredAddressDetail.ProofTypeId;
        axiosHelper.post(`${API.addAndUpdateKYS1ContactDetail}`, payload).then((response) => {
            if (response.data.IsSuccessful) {
                notify.success(response?.data?.Data?.Message);
                props.toggleKys1FormTabs("2")
                hidePageLoader()
            }
        }).catch((error) => {
            hidePageLoader();
            if (error.response.status === 401) {
                apiErrors(error)
            } else {

                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage)
                }
            }
        });
    }

    const getProofTypeList = () => {
        axiosHelper.get(`${API.getProofTypeList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                proofTypeListData = list;
                setProofTypeList(list)
            }
        }).catch((error) => {
            apiErrors(error);
            throw error; // Re-throw the error to the caller
        });
    }

    const getCategoryMaster = () => {
        axiosHelper.get(`${API.GetCategoryMaster}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                setCategoryList(list)
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getTypeOfEstablishment = (supplierDetail) => {
        getTypeEstablishment()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let list = res?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                    if (supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2) {
                        list = list.filter((el) => el.value !== 5);
                    }
                    setEstablishmentTypes(list);
                }
            }).catch(() => { });
    };

    const getCountryMasterList = (supplierDetail) => {
        getCountryService()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let formattedList = res?.Data.map(el => ({ label: el.Name, value: el.Id }));
                    setCountryListForOwners(formattedList);
                    // For overseas supplier remove India from country list
                    if (supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2) {
                        let countryListWithoutIndia = formattedList.filter((record) => record.label !== "India");
                        setCountryList(countryListWithoutIndia);
                    }
                    if (supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1) {
                        let indiaCountry = formattedList.find((record) => record.label === "India");
                        setCountryList([indiaCountry]);
                    }
                }

            })
            .catch(() => { });
    };

    async function handleCountryChange(selectedValue, addressType = "", isOnchange = true) {
        const stateRes = await getStateSelection(
            selectedValue?.value || selectedValue
        );
        let list = stateRes?.Data?.StateList.map(el => ({ label: el.Name, value: el.Id }));
        if (addressType === 'work') {
            if (isOnchange) {
                setValue("VendorWorkAddressDetail.StateId", null);
            }
            setWorkAddressCountryStateList(list);
        }
        if (addressType === 'registered') {
            if (isOnchange) {
                setValue("VendorRegisteredAddressDetail.StateId", null);
            }
            setRegisteredAddressCountryStateList(list);
        }
    }

    const addOwners = (totalOwnersToAdd, editMode) => {
        const records = Array.from({ length: totalOwnersToAdd }, (_, index) => (ownerInitialData));
        if (editMode) {
            setTimeout(() => {
                append(records);
            }, 1000);
        } else {
            append(records);
        }
    }

    // const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {
    //     const currentFileConfiguration = fileConfig[fileIdentifier];
    //     if (file.size <= (currentFileConfiguration.maxSize * 1024 * 1024)) {
    //         const reader = new FileReader();
    //         reader.onload = (event) => {
    //             let base64String = event.target.result;
    //             // Remove the data type prefix
    //             base64String = base64String.replace(/^data:(.*?);base64,/, "");
    //             // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
    //             const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
    //             const isTypeValid = allowedFileTypes?.includes(file.type);
    //             if (!isTypeValid) {
    //                 // Handle the case where the file type is not allowed
    //                 notify.error(currentFileConfiguration.validationMessage);
    //                 setValue(formFieldKey, null)
    //                 return;
    //             } else {
    //                 // Pass file name, base64String, and fileType to setGstinFile
    //                 let selectedFile = { fileName: file.name, base64String, fileType: file.type };
    //                 setCurrentFile(selectedFile);
    //                 setValue(formFieldKey, selectedFile)
    //                 trigger(formFieldKey)
    //             }
    //         };
    //         reader.readAsDataURL(file);
    //     } else {
    //         // Handle the case where the file size exceeds 5 MB
    //         notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
    //         setValue(formFieldKey, null)
    //     }
    // };

    const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {
        const currentFileConfiguration = fileConfig[fileIdentifier];

        // Check for spaces and special characters in filename
        const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
        const hasSpaces = /\s/.test(file.name);

        if (hasSpaces || hasSpecialChars) {
            notify.error(
                "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
            );
            setValue(formFieldKey, null);
            return;
        }

        if (file.size <= (currentFileConfiguration.maxSize * 1024 * 1024)) {
            const reader = new FileReader();
            reader.onload = (event) => {
                let base64String = event.target.result;
                // Remove the data type prefix
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
                const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
                const isTypeValid = allowedFileTypes?.includes(file.type);
                if (!isTypeValid) {
                    // Handle the case where the file type is not allowed
                    notify.error(currentFileConfiguration.validationMessage);
                    setValue(formFieldKey, null);
                    return;
                } else {
                    // Pass file name, base64String, and fileType to setGstinFile
                    let selectedFile = { fileName: file.name, base64String, fileType: file.type };
                    setCurrentFile(selectedFile);
                    setValue(formFieldKey, selectedFile);
                    trigger(formFieldKey);
                }
            };

            reader.onerror = () => {
                notify.error("Error uploading file, please connect with your IT team");
                setValue(formFieldKey, null);
            };

            reader.readAsDataURL(file);
        } else {
            // Handle the case where the file size exceeds 5 MB
            notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
            setValue(formFieldKey, null);
        }
    };
    const removeOwners = (rowIndex) => {
        remove(rowIndex)
        let formValues = formController.getValues();
        reset(formValues);

    }

    const setOwnersBasedOnCompanyType = (companyType, DomesticandOverseas, editMode = false) => {
        //For overseas supplier minimum 1 owner is requried for all company type
        if (DomesticandOverseas === 2) {
            // setValue("OwnersShipDetail", [])
            let removeKeys = fields.map((_, index) => index);

            remove(removeKeys);
            setTimeout(() => {
                addOwners(1, editMode)
            }, 300);
            return;
        }
        // For indian supplier, company type "Company", "LLP", "Partnership" min. two owners details is mandatory        
        if (
            DomesticandOverseas === 1 &&
            (
                companyType === 1 ||
                companyType === 3 ||
                companyType === 4
            )
        ) {
            // setValue("OwnersShipDetail", [])
            let removeKeys = fields.map((_, index) => index);

            remove(removeKeys);
            setTimeout(() => {
                addOwners(2, editMode)
            }, 300);
            return;
        }
        // For indian supplier, company type "HUF", "OPC", "Proprietorship", "Society" min. 1 owner details is mandatory        
        if (
            DomesticandOverseas === 1 &&
            (
                companyType === 2 ||
                companyType === 5 ||
                companyType === 6 ||
                companyType === 7
            )
        ) {
            // setValue("OwnersShipDetail", [])
            let removeKeys = fields.map((_, index) => index);

            remove(removeKeys);
            setTimeout(() => {
                addOwners(1, editMode)
            }, 300);
            return;
        }
    }

    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
            <div className="container-fluid contactDetailsWrapper shadow-lgg login-formg">
                <div className="signup-form">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="p-relative">
                                <div>
                                    {
                                        !supplierDetail?.IsKYS1Editable && (
                                            <div className='disableKys1Form'>  </div>
                                        )
                                    }
                                    <form onSubmit={handleSubmit(onSubmitContactDetails)}>
                                        <Row className="part-detail-wrapper mt-2">
                                            <Col md="12">
                                                <div className='hl-right-radio'>
                                                    <div className="hl-title-tooltip">
                                                        <HeaderTitle
                                                            title={"Supplier Origin:"}
                                                            customClass="mt-2 hl-supplier-title"
                                                        />
                                                    </div>
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl-2 pr-5 mr-5 pr-4 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            className="zero-based"
                                                            value="1"
                                                            {...register("RegistrationDetail.DomesticandOverseas")}
                                                            disabled
                                                        />
                                                        <span>Indian</span>
                                                    </Label>
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            className="vendor-based"
                                                            value="2"
                                                            {...register("RegistrationDetail.DomesticandOverseas")}
                                                            disabled
                                                        />
                                                        <span>Overseas</span>
                                                    </Label>
                                                </div>
                                            </Col>
                                            <Col md="12"><hr className="hr-seprator" /></Col>
                                            <Col md="3" className="d-flex justify-content-start align-items-center">
                                                <div className="hl-title-tooltip">
                                                    <Label className="d-inline-block pl-1 mr-5 pt-0 mb-3">
                                                        Supplier Relation
                                                        <span className="asterisk-required">*</span>
                                                    </Label>
                                                </div>
                                                <div className="mb-2">
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            className="zero-based"
                                                            value={1}
                                                            {...register("RegistrationDetail.VendorRelation")}
                                                            disabled
                                                        />
                                                        <span>New</span>
                                                    </Label>
                                                    <Label
                                                        className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                                        check
                                                    >
                                                        <input
                                                            type="radio"
                                                            className="vendor-based"
                                                            value={2}
                                                            {...register("RegistrationDetail.VendorRelation")}
                                                            disabled
                                                        />
                                                        <span>Existing</span>
                                                    </Label>
                                                </div>
                                            </Col>
                                            <Row className='mt-4'>
                                                <Col md="3" className="hl-error-cmtitle">
                                                    <TextFieldHookForm
                                                        // {...register("RegistrationDetail.CompanyName")}
                                                        name="RegistrationDetail.CompanyName"
                                                        register={register}
                                                        label={`Company Name`}
                                                        rules={{
                                                            required: true,
                                                            validate: {
                                                                checkWhiteSpaces,
                                                                //  alphaNumeric
                                                            },
                                                            maxLength: 250,
                                                        }}
                                                        Controller={Controller}
                                                        control={control}
                                                        placeholder={"Enter"}
                                                        handleChange={() => { }}
                                                        customClassName={"withBorder"}
                                                        errors={errors?.RegistrationDetail?.CompanyName}
                                                        disabled={false}
                                                        mandatory={true}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <SearchableSelectHookForm
                                                        // {...register("RegistrationDetail.CompanyTypeId")}
                                                        name="RegistrationDetail.CompanyTypeId"
                                                        register={register}
                                                        options={establishmentTypes}
                                                        label="Company Type"
                                                        rules={{ required: true }}
                                                        placeholder="Select"
                                                        Controller={Controller}
                                                        control={control}
                                                        mandatory={true}
                                                        errors={errors?.RegistrationDetail?.CompanyTypeId}
                                                        disabled={false}
                                                        handleChange={(companyType) => {
                                                            setOwnersBasedOnCompanyType(companyType?.value, supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas);
                                                        }}
                                                    />
                                                </Col>
                                                <Col md="3">
                                                    <SearchableSelectHookForm
                                                        // {...register("RegistrationDetail.VendorCategoryId")}
                                                        name="RegistrationDetail.VendorCategoryId"
                                                        register={register}
                                                        options={categoryList}
                                                        label="Supplier Category"
                                                        // rules={{ required: true }}
                                                        placeholder="Select"
                                                        Controller={Controller}
                                                        control={control}
                                                        mandatory={true}
                                                        errors={errors?.RegistrationDetail?.VendorCategoryId}
                                                        disabled={true}
                                                        handleChange={() => { }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Row >
                                        <hr className="hr-seprator" />
                                        <Row className="part-detail-wrapper">
                                            <Col md="12">
                                                <HeaderTitle title={<>Work Address: <small>
                                                    {
                                                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 &&
                                                        "(As per GST certificate for Billing)"
                                                    }
                                                    {
                                                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 &&
                                                        "(for billing as per Proforma Invoice or commercial invoice)"
                                                    }
                                                </small>
                                                </>} customClass="mt-4" />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.House")}
                                                    name="VendorWorkAddressDetail.House"
                                                    register={register}
                                                    label={`Building/Plot No.`}
                                                    Controller={Controller}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces },
                                                        maxLength: 100,
                                                    }}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.House}
                                                    disabled={false}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.Street")}
                                                    name="VendorWorkAddressDetail.Street"
                                                    register={register}
                                                    label={`Street`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces },
                                                        maxLength: 100,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.Street}
                                                    disabled={false}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.City")}
                                                    name="VendorWorkAddressDetail.City"
                                                    register={register}
                                                    label={"City"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, alphaNumeric },
                                                        maxLength: 50,
                                                    }}
                                                    mandatory={true}
                                                    handleChange={() => { }}
                                                    errors={errors?.VendorWorkAddressDetail?.City}
                                                    disabled={false}
                                                    customClassName={"withBorder"}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.District")}
                                                    name="VendorWorkAddressDetail.District"
                                                    register={register}
                                                    label={`District`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    rules={{
                                                        // For Indian supplier "District" is required
                                                        required: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1,
                                                        validate: { checkWhiteSpaces, alphaNumeric },
                                                        maxLength: 50,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.District}
                                                    disabled={false}
                                                    // For Indian supplier "District" is required
                                                    mandatory={supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    // {...register("VendorWorkAddressDetail.CountryId")}
                                                    name="VendorWorkAddressDetail.CountryId"
                                                    register={register}
                                                    label={"Country"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: true }}
                                                    mandatory={true}
                                                    errors={errors?.VendorWorkAddressDetail?.CountryId}
                                                    disabled={supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1}
                                                    options={countryList}
                                                    handleChange={(value) => {
                                                        handleCountryChange(value, 'work');
                                                    }}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    // {...register("VendorWorkAddressDetail.StateId")}
                                                    name="VendorWorkAddressDetail.StateId"
                                                    register={register}
                                                    label={"State/Region"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    options={workAddressCountryStateList}
                                                    rules={{ required: true }}
                                                    mandatory={true}
                                                    handleChange={() => { }}
                                                    errors={errors?.VendorWorkAddressDetail?.StateId}
                                                    disabled={false}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.PostalCode")}
                                                    name="VendorWorkAddressDetail.PostalCode"
                                                    register={register}
                                                    label={`Postal Code/Zip Code`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: true,
                                                        validate: {
                                                            checkWhiteSpaces,
                                                            ...(supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2
                                                                ? { alphaNumeric }
                                                                : { number }),
                                                        },
                                                        maxLength: 10,
                                                        minLength: {
                                                            value: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 ? 4 : 6,
                                                            message:
                                                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2
                                                                    ? "Minimum length is 4."
                                                                    : "Minimum length is 6.",
                                                        },
                                                    }}
                                                    placeholder={"Enter"}
                                                    className=""
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.PostalCode}
                                                    handleChange={() => { }}
                                                    disabled={false}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="mobileNoTooltip"
                                                    tooltipText="Primary mobile number for communication for this application."
                                                />
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.Mobile")}
                                                    name="VendorWorkAddressDetail.Mobile"
                                                    register={register}
                                                    label={`Mobile Number`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, number },
                                                        maxLength: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 ? 15 : 10,
                                                        minLength: {
                                                            value: 10,
                                                            message: "Minimum length is 10.",
                                                        },
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.Mobile}
                                                    handleChange={() => { }}
                                                    mandatory={true}
                                                    placeholder={"Enter"}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.Mobile")}
                                                    name="VendorWorkAddressDetail.TelephoneNumber"
                                                    register={register}
                                                    label={`Telephone Number`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: false,
                                                        validate: { checkWhiteSpaces, number },
                                                        maxLength: 15,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.TelephoneNumber}
                                                    handleChange={() => { }}
                                                    mandatory={false}
                                                    placeholder={"Enter"}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="emailTooltip"
                                                    tooltipText="Primary email for communication for this application."
                                                />
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.Email")}
                                                    name="VendorWorkAddressDetail.Email"
                                                    register={register}
                                                    label={`Primary Email Address`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, email },
                                                        maxLength: 50,
                                                    }}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.Email}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="emailTooltip"
                                                    tooltipText="Primary email for communication for this application."
                                                />
                                                <TextFieldHookForm
                                                    // {...register("VendorWorkAddressDetail.NotificationsEmail")}
                                                    name="VendorWorkAddressDetail.NotificationsEmail"
                                                    register={register}
                                                    label={`Quality Notifications Email`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, email },
                                                        maxLength: 100,
                                                    }}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorWorkAddressDetail?.NotificationsEmail}
                                                    mandatory={true}
                                                />
                                            </Col>

                                        </Row>
                                        <hr className="hr-seprator" />
                                        <Row className="part-detail-wrapper">
                                            <Col md="12">
                                                <HeaderTitle title={<>Work Address Proof <small>(Upload Document)</small></>} customClass="mt-4" />
                                            </Col>
                                            <Col md="12">
                                                <div className="d-flex flex-wrap mb-4">
                                                    <Label className={"d-inline-block pt-4 radio-box form-check-label w-auto mr-5"} check >
                                                        <input
                                                            type="radio"
                                                            className="zero-based"
                                                            {...register("VendorWorkAddressDetail.WorkAddressType", { required: radioValidateMsg })}
                                                            value="owned"
                                                        />
                                                        <span> Owned
                                                            <TooltipCustom
                                                                id="ownedTooltip"
                                                                customClass="ml-5"
                                                                tooltipText="Proof document should be latest and have address matching the work address."
                                                            />
                                                        </span>
                                                    </Label>
                                                    <Label className="d-inline-block pt-4 radio-box form-check-label w-auto ml-5" >
                                                        <input
                                                            type="radio"
                                                            {...register("VendorWorkAddressDetail.WorkAddressType", { required: radioValidateMsg })}
                                                            className="vendor-based"
                                                            value="rented"
                                                        />
                                                        <span>Rented
                                                            <TooltipCustom
                                                                id="rentedTooltip"
                                                                customClass="ml-5"
                                                                tooltipText="Rent Agreement"
                                                            />
                                                        </span>
                                                    </Label>
                                                    {errors?.VendorWorkAddressDetail?.WorkAddressType && (
                                                        <div className="text-help w-100">
                                                            {errors?.VendorWorkAddressDetail?.WorkAddressType?.message}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md="3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <SearchableSelectHookForm
                                                            // {...register("VendorWorkAddressDetail.ProofTypeId")}
                                                            name="VendorWorkAddressDetail.ProofTypeId"
                                                            register={register}
                                                            label="Select Proof Type"
                                                            rules={{ required: true }}
                                                            placeholder="Select"
                                                            Controller={Controller}
                                                            control={control}
                                                            options={proofTypeList}
                                                            mandatory={true}
                                                            errors={errors?.VendorWorkAddressDetail?.ProofTypeId}
                                                            disabled={false}
                                                            handleChange={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md="3" className='d-flex'>
                                                <div className='w-100 d-flex align-items-center mt-1'>
                                                    <Label className='d-inline-block radio-box form-check-label w-auto form-label'>&nbsp;</Label>
                                                    {
                                                        isWorkAddressTypeRented && (
                                                            <div className="d-flex align-items-center hl-taxation-wrap w-100">
                                                                <div className="fullinput-icon">
                                                                    <label>
                                                                        Agreement Expiry Date
                                                                        <span className="asterisk-required">*</span>
                                                                    </label>
                                                                    <div className="inputbox date-section">
                                                                        <Controller
                                                                            control={control}
                                                                            name="VendorWorkAddressDetail.AgreementExpiryDate"
                                                                            rules={{ required: radioValidateMsg }}
                                                                            render={({ field }) => (
                                                                                <>
                                                                                    <DatePicker
                                                                                        placeholderText="Select Date"
                                                                                        onChange={(date) => field.onChange(date)}
                                                                                        selected={field.value}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        autoComplete="off"
                                                                                        disabledKeyboardNavigation
                                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                                        className='form-control hl-datepicker-date mh-inherit'
                                                                                        minDate={tomorrowDate}
                                                                                    />
                                                                                    {errors && <span className="text-help">{errors?.VendorWorkAddressDetail?.AgreementExpiryDate?.message}</span>}
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    <div className="inputbox date-section"></div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    <FileUpload
                                                        uploadClass="hl-iso-upload"
                                                        control={control}
                                                        {...register("VendorWorkAddressDetail.OwnRentedDocumentAttachment")}
                                                        onFileChange={(file) => handleAttachmentUpload(file, "rentAgreementAttachment", setRentAgreementAttachment, "VendorWorkAddressDetail.OwnRentedDocumentAttachment")}
                                                        onDelete={() => {
                                                            setValue("VendorWorkAddressDetail.OwnRentedDocumentAttachment", null);
                                                            setRentAgreementAttachment(p => ({ ...p, isRemove: true }))
                                                        }}
                                                        uploadedFile={rentAgreementAttachment}
                                                        setUploadedFile={setRentAgreementAttachment}
                                                        allowedFileTypes={fileConfig.rentAgreementAttachment.allowedFileTypes}
                                                        rules={{ required: "File required" }}
                                                        mandatory={true}
                                                        errors={errors?.VendorWorkAddressDetail?.OwnRentedDocumentAttachment}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <hr className="hr-seprator" />
                                        <Row className="part-detail-wrapper">
                                            <Col md="12">
                                                <HeaderTitle title={"Registered Address"} customClass="mt-4" />
                                                <Label className='my-3 d-block custom-checkbox'>
                                                    Same as work address
                                                    <input
                                                        type='checkbox'
                                                        className='mr-2'
                                                        checked={isRegisteredAddressSameAsWork}
                                                        onChange={() => toggleRegisteredAddressSameAsWork(isRegisteredAddressSameAsWork)}
                                                    />
                                                    <span className="before-box"></span>
                                                </Label>
                                            </Col>
                                            <Col md="12">
                                                <Row className="part-detail-wrapper">
                                                </Row>
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.House")}
                                                    name="VendorRegisteredAddressDetail.House"
                                                    register={register}
                                                    label={`Building/Plot No.`}
                                                    Controller={Controller}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces },
                                                        maxLength: 100,
                                                    }}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.House}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.Street")}
                                                    name="VendorRegisteredAddressDetail.Street"
                                                    register={register}
                                                    label={`Street`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces },
                                                        maxLength: 100,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.Street}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.City")}
                                                    name="VendorRegisteredAddressDetail.City"
                                                    register={register}
                                                    label={`City`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, alphaNumeric },
                                                        maxLength: 50,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.City}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.District")}
                                                    name="VendorRegisteredAddressDetail.District"
                                                    register={register}
                                                    label={`District`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    handleChange={() => { }}
                                                    rules={{
                                                        // For Indian supplier "District" is required
                                                        required: (registeredAddressCountry?.value === 101),
                                                        validate: { checkWhiteSpaces, alphaNumeric },
                                                        maxLength: 50,
                                                    }}

                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.District}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    // For Indian supplier "District" is required
                                                    mandatory={(registeredAddressCountry?.value === 101)}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    // {...register("VendorRegisteredAddressDetail.CountryId")}
                                                    name="VendorRegisteredAddressDetail.CountryId"
                                                    register={register}
                                                    label={"Country"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: true }}
                                                    mandatory={true}
                                                    errors={errors?.VendorRegisteredAddressDetail?.CountryId}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    options={countryListForOwners}
                                                    handleChange={(value) => {
                                                        handleCountryChange(value, 'registered');
                                                    }}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <SearchableSelectHookForm
                                                    // {...register("VendorRegisteredAddressDetail.StateId")}
                                                    name="VendorRegisteredAddressDetail.StateId"
                                                    register={register}
                                                    label={"State/Region"}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: true }}
                                                    mandatory={true}
                                                    handleChange={() => { }}
                                                    errors={errors?.VendorRegisteredAddressDetail?.StateId}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    options={registeredAddressCountryStateList}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.PostalCode")}
                                                    name="VendorRegisteredAddressDetail.PostalCode"
                                                    register={register}
                                                    label={`Postal Code/Zip Code`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: true,
                                                        validate: {
                                                            checkWhiteSpaces,
                                                            ...(supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2
                                                                ? { alphaNumeric }
                                                                : { number }),
                                                        },
                                                        maxLength: 10,
                                                        minLength: {
                                                            value: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 ? 4 : 6,
                                                            message:
                                                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2
                                                                    ? "Minimum length is 4."
                                                                    : "Minimum length is 6.",
                                                        },
                                                    }}
                                                    placeholder={"Enter"}
                                                    className=""
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.PostalCode}
                                                    handleChange={() => { }}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="mobileNoTooltip2"
                                                    tooltipText="Primary mobile number for communication for this application."
                                                />
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.Mobile")}
                                                    name="VendorRegisteredAddressDetail.Mobile"
                                                    register={register}
                                                    label={`Mobile Number`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, number },
                                                        maxLength: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 ? 15 : 10,
                                                        minLength: {
                                                            value: 10,
                                                            message: "Minimum length is 10.",
                                                        },
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.Mobile}
                                                    handleChange={() => { }}
                                                    mandatory={true}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    placeholder={"Enter"}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.Mobile")}
                                                    name="VendorRegisteredAddressDetail.TelephoneNumber"
                                                    register={register}
                                                    label={`Telephone Number`}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{
                                                        required: false,
                                                        validate: { checkWhiteSpaces, number },
                                                        maxLength: 15,
                                                    }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.TelephoneNumber}
                                                    handleChange={() => { }}
                                                    mandatory={false}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                    placeholder={"Enter"}
                                                />
                                            </Col>
                                            <Col md="3">
                                                <TooltipCustom
                                                    id="emailTooltip2"
                                                    tooltipText={
                                                        <>
                                                            Primary email for communication for this
                                                            application.
                                                        </>
                                                    }
                                                />
                                                <TextFieldHookForm
                                                    // {...register("VendorRegisteredAddressDetail.Email")}
                                                    name="VendorRegisteredAddressDetail.Email"
                                                    register={register}
                                                    label={`Primary Email Address`}
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: true,
                                                        validate: { checkWhiteSpaces, email },
                                                        maxLength: 100,
                                                    }}
                                                    handleChange={() => { }}
                                                    customClassName={"withBorder"}
                                                    errors={errors?.VendorRegisteredAddressDetail?.Email}
                                                    mandatory={true}
                                                    disabled={isRegisteredAddressSameAsWork}
                                                />
                                            </Col>
                                        </Row>
                                        <hr className="hr-seprator" />
                                        <Row className="part-detail-wrapper">
                                            <Col md="12">
                                                <HeaderTitle title={"Ownership Details"} customClass="mt-4" />
                                                <span></span>
                                            </Col>
                                            <Col className='d-flex justify-space-between align-items-center inputwith-icon mb-0' md="3">
                                                <div className='fullinput-icon'>
                                                    <TextFieldHookForm
                                                        className="width-full"
                                                        // {...register("RegistrationDetail.NumberOfOwners")}
                                                        name="RegistrationDetail.NumberOfOwners"
                                                        register={register}
                                                        label={`No. of Owners`}
                                                        Controller={Controller}
                                                        control={control}
                                                        placeholder={"Enter"}
                                                        handleChange={() => { }}
                                                        rules={{
                                                            required: true,
                                                            validate: { checkWhiteSpaces, number },
                                                            maxLength: 2,
                                                        }}
                                                        customClassName={"withBorder width-full mb-0"}
                                                        errors={errors.RegistrationDetail?.NumberOfOwners}
                                                        disabled={true}
                                                        mandatory={true}
                                                    />
                                                </div>
                                                <div onClick={() => addOwners(1)} className={'plus-icon-square right'}></div>
                                            </Col>
                                        </Row>
                                        <div className="hl-nsa-review-details hl-kys-contact-details">
                                            <table className='w-100'>
                                                <thead>
                                                    <tr>
                                                        <th> Name <span className="asterisk-required">*</span> </th>
                                                        <th>City <span className="asterisk-required">*</span></th>
                                                        <th>Country <span className="asterisk-required">*</span></th>
                                                        <th>Date of Birth</th>
                                                        <th>Mobile No
                                                            <span className="asterisk-required">*</span>
                                                        </th>
                                                        <th>Email
                                                            <span className="asterisk-required">*</span>
                                                        </th>
                                                        {
                                                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 && (
                                                                <>
                                                                    <th>Aadhar No.  </th>
                                                                    <th>PAN No.
                                                                        {
                                                                            //For Indian supplier with company type as “HUF”,"Partenershiop","Proprietorship", "Society" Pan No is  required.  
                                                                            (
                                                                                registrationDetailCompanyTypeId?.value == 2 ||
                                                                                registrationDetailCompanyTypeId?.value == 3 ||
                                                                                registrationDetailCompanyTypeId?.value == 5 ||
                                                                                registrationDetailCompanyTypeId?.value == 7
                                                                            ) && (
                                                                                <span className="asterisk-required">*</span>
                                                                            )
                                                                        }
                                                                    </th>
                                                                    <th>DIN No.
                                                                        {
                                                                            //For Indian supplier with company type as “Company”,"OPC","LLP" DinNo is required.
                                                                            (
                                                                                registrationDetailCompanyTypeId?.value == 1 ||
                                                                                registrationDetailCompanyTypeId?.value == 4 ||
                                                                                registrationDetailCompanyTypeId?.value == 6
                                                                            ) && (
                                                                                <span className="asterisk-required">*</span>
                                                                            )
                                                                        }
                                                                    </th>
                                                                </>
                                                            )
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {fields.map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <td >
                                                                <TextFieldHookForm
                                                                    // {...register(`OwnersShipDetail.${index}.Name`)}
                                                                    name={`OwnersShipDetail.${index}.Name`}
                                                                    register={register}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    handleChange={() => { }}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: { checkWhiteSpaces, alphabetsOnly },
                                                                        maxLength: 100,
                                                                    }}
                                                                    customClassName={"withBorder mh-inherit mb-0"}
                                                                    errors={errors?.OwnersShipDetail?.[index]?.Name}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                    placeholder="Enter*"
                                                                    label={false}
                                                                />
                                                            </td>
                                                            <td>
                                                                <TextFieldHookForm
                                                                    // {...register(`OwnersShipDetail.${index}.City`)}
                                                                    name={`OwnersShipDetail.${index}.City`}
                                                                    register={register}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    handleChange={() => { }}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: { checkWhiteSpaces, alphabetsOnly },
                                                                        maxLength: 100,
                                                                    }}
                                                                    customClassName={"withBorder mh-inherit mb-0"}
                                                                    errors={errors?.OwnersShipDetail?.[index]?.City}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                    placeholder="Enter*"
                                                                    label={false}
                                                                />
                                                            </td>
                                                            <td>
                                                                <SearchableSelectHookForm
                                                                    // {...register(`OwnersShipDetail.${index}.CountryId`)}
                                                                    name={`OwnersShipDetail.${index}.CountryId`}
                                                                    register={register}
                                                                    placeholder={"Select*"}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    rules={{ required: true }}
                                                                    mandatory={true}
                                                                    errors={errors?.OwnersShipDetail?.[index]?.CountryId}
                                                                    disabled={false}
                                                                    options={countryListForOwners}
                                                                    handleChange={(value) => { }}
                                                                    customClassName="mb-0 mh-inherit"
                                                                    label={false}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Controller
                                                                    control={control}
                                                                    name={`OwnersShipDetail[${index}].DateOfBirth`}
                                                                    render={({ field }) => (
                                                                        <DatePicker
                                                                            placeholderText="Select Date"
                                                                            onChange={(date) => field.onChange(date)}
                                                                            selected={field.value}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            disabledKeyboardNavigation
                                                                            onChangeRaw={(e) => e.preventDefault()}
                                                                            className='form-control hl-datepicker-date mh-inherit'
                                                                            maxDate={maxDateForDateOfBirth}
                                                                        />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                <TextFieldHookForm
                                                                    // {...register(`OwnersShipDetail.${index}.Mobile`)}
                                                                    name={`OwnersShipDetail.${index}.Mobile`}
                                                                    register={register}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    handleChange={() => { }}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: { checkWhiteSpaces, number },
                                                                        maxLength: supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 ? 15 : 10,
                                                                        minLength: {
                                                                            value: 10,
                                                                            message: "Minimum length is 10.",
                                                                        },
                                                                    }}
                                                                    customClassName={"withBorder mh-inherit mb-0"}
                                                                    errors={errors?.OwnersShipDetail?.[index]?.Mobile}
                                                                    disabled={false}
                                                                    mandatory={false}
                                                                    placeholder="Enter"
                                                                    label={false}
                                                                />
                                                            </td>
                                                            <td>
                                                                <TextFieldHookForm
                                                                    // {...register(`OwnersShipDetail.${index}.Email`)}
                                                                    name={`OwnersShipDetail.${index}.Email`}
                                                                    register={register}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    handleChange={() => { }}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: { checkWhiteSpaces, email },
                                                                        maxLength: 100,
                                                                    }}
                                                                    customClassName={"withBorder mh-inherit mb-0"}
                                                                    errors={errors?.OwnersShipDetail?.[index]?.Email}
                                                                    disabled={false}
                                                                    mandatory={false}
                                                                    placeholder="Enter"
                                                                    label={false}
                                                                />
                                                            </td>
                                                            {
                                                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 && (
                                                                    <>
                                                                        <td>
                                                                            <TextFieldHookForm
                                                                                // {...register(`OwnersShipDetail.${index}.AadharNo`)}
                                                                                name={`OwnersShipDetail.${index}.AadharNo`}
                                                                                register={register}
                                                                                Controller={Controller}
                                                                                control={control}
                                                                                handleChange={() => { }}
                                                                                rules={{
                                                                                    //For Indian supplier Aadhar is required.
                                                                                    validate: {
                                                                                        checkWhiteSpaces,
                                                                                        validateNumberTypeWithLength: (value) => validateNumberTypeWithLength(value, 12),
                                                                                    }
                                                                                }}
                                                                                customClassName={"withBorder AadharNoInput mh-inherit mb-0"}
                                                                                errors={errors?.OwnersShipDetail?.[index]?.AadharNo}
                                                                                disabled={false}
                                                                                mandatory={false}
                                                                                placeholder="Enter"
                                                                                label={false}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <TextFieldHookForm
                                                                                // {...register(`OwnersShipDetail.${index}.PanNo`)}
                                                                                name={`OwnersShipDetail.${index}.PanNo`}
                                                                                register={register}
                                                                                Controller={Controller}
                                                                                control={control}
                                                                                handleChange={(e) => {
                                                                                    // Convert input value to uppercase
                                                                                    const uppercaseValue = e.target.value.toUpperCase();
                                                                                    e.target.value = uppercaseValue;
                                                                                }}
                                                                                rules={{
                                                                                    //For Indian supplier with company type as “HUF”,"Partenershiop","Proprietorship", "Society" Pan No is  required.  
                                                                                    required:
                                                                                        (
                                                                                            registrationDetailCompanyTypeId?.value == 2 ||
                                                                                            registrationDetailCompanyTypeId?.value == 3 ||
                                                                                            registrationDetailCompanyTypeId?.value == 5 ||
                                                                                            registrationDetailCompanyTypeId?.value == 7
                                                                                        ),
                                                                                    validate: { checkWhiteSpaces, alphaNumeric, isValidPAN },
                                                                                    maxLength: 10,
                                                                                    minLength: {
                                                                                        value: 10,
                                                                                        message: "Minimum length is 10 characters",
                                                                                    },
                                                                                }}
                                                                                customClassName={"withBorder mh-inherit mb-0"}
                                                                                errors={errors?.OwnersShipDetail?.[index]?.PanNo}
                                                                                disabled={false}
                                                                                mandatory={false}
                                                                                placeholder="Enter"
                                                                                label={false}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <TextFieldHookForm
                                                                                // {...register(`OwnersShipDetail.${index}.DinNo`)}
                                                                                name={`OwnersShipDetail.${index}.DinNo`}
                                                                                register={register}
                                                                                Controller={Controller}
                                                                                control={control}
                                                                                handleChange={(e) => {
                                                                                    // Convert input value to uppercase
                                                                                    const uppercaseValue = e.target.value.toUpperCase();
                                                                                    e.target.value = uppercaseValue;
                                                                                }}
                                                                                rules={{
                                                                                    //For Indian supplier with company type as “Company”,"OPC","LLP" DinNo is required.
                                                                                    required:
                                                                                        (
                                                                                            registrationDetailCompanyTypeId?.value == 1 ||
                                                                                            registrationDetailCompanyTypeId?.value == 4 ||
                                                                                            registrationDetailCompanyTypeId?.value == 6
                                                                                        ),
                                                                                    validate: { checkWhiteSpaces },
                                                                                    maxLength: 25,
                                                                                }}
                                                                                customClassName={"withBorder mh-inherit mb-0"}
                                                                                errors={errors?.OwnersShipDetail?.[index]?.DinNo}
                                                                                disabled={false}
                                                                                mandatory={false}
                                                                                placeholder="Enter"
                                                                                label={false}
                                                                            />
                                                                        </td>
                                                                    </>
                                                                )
                                                            }
                                                            <td>
                                                                <div className="manage-table-action">
                                                                    {fields.length > 1 && (
                                                                        <button title="Delete" className="Delete" onClick={() => removeOwners(index)} type="button"></button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {/* </AgGridReact> */}
                                        </div>
                                        <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer mt-3">
                                            <div className="col-sm-12 text-right bluefooter-butn">
                                                <button
                                                    type="submit"
                                                    className="submit-button save-btn me-2"
                                                >
                                                    <div className="save-icon mr-1"></div>
                                                    {"Next"}
                                                </button>
                                            </div>
                                        </Row>
                                    </form >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >
        </>
    )
}

export default ContactDetails;
